import {
  ITAU_COMPLIANCE_STATUS_COLORS,
  ITAU_COMPLIANCE_STATUS_TEXT,
} from '../compliance-requirement-status';

export const COMPLIANCE_REQUIREMENT_STRATEGIES = {
  REGCHEQ: 'REGCHEQ',
  EXTERNAL: 'EXTERNAL',
  NONE: 'NONE',
};

export const COMPLIANCE_PLATFORM_FEATURES = {
  COMPLIANCE_REQUIREMENT_STRATEGY: 'compliance.requirement.strategy',
  COMPLIANCE_REQUIREMENT_STATUS_COLORS: 'compliance.requirement.statusColors',
  COMPLIANCE_REQUIREMENT_STATUS_TEXT: 'compliance.requirement.statusText',
};

export const COMPLIANCE_PLATFORM_FEATURE_CONFIG = {
  BCH: {
    [COMPLIANCE_PLATFORM_FEATURES.COMPLIANCE_REQUIREMENT_STRATEGY]:
      COMPLIANCE_REQUIREMENT_STRATEGIES.NONE,
  },

  SANTANDER: {
    [COMPLIANCE_PLATFORM_FEATURES.COMPLIANCE_REQUIREMENT_STRATEGY]:
      COMPLIANCE_REQUIREMENT_STRATEGIES.NONE,
  },

  FINGO: {
    [COMPLIANCE_PLATFORM_FEATURES.COMPLIANCE_REQUIREMENT_STRATEGY]:
      COMPLIANCE_REQUIREMENT_STRATEGIES.REGCHEQ,
  },

  ITAU: {
    [COMPLIANCE_PLATFORM_FEATURES.COMPLIANCE_REQUIREMENT_STRATEGY]:
      COMPLIANCE_REQUIREMENT_STRATEGIES.EXTERNAL,
    [COMPLIANCE_PLATFORM_FEATURES.COMPLIANCE_REQUIREMENT_STATUS_COLORS]:
      ITAU_COMPLIANCE_STATUS_COLORS,
    [COMPLIANCE_PLATFORM_FEATURES.COMPLIANCE_REQUIREMENT_STATUS_TEXT]:
      ITAU_COMPLIANCE_STATUS_TEXT,
  },
};
